<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-xs-12 col-md-6 vcenter">
      <h3>Quality Control Config</h3>
    </div>
    <div class="col-xs-12 col-md-6  vcenter-right">
      <div>
      </div>
    </div>
  </div>
  <hr style="margin-top:2px;margin-bottom:2px" />

  <mat-accordion>
    <mat-expansion-panel >
      <mat-expansion-panel-header>
        <mat-panel-title>General</mat-panel-title>
        <mat-panel-description><i>Areas, Contract Numbers, Deficiency Types, Observation Comment Types, Origin Types, Root Causes, Responsible Mgrs</i></mat-panel-description>
      </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <mat-tab-group>
          <mat-tab label="Areas">
            <ng-template matTabContent>
              <app-qc-areas></app-qc-areas>
            </ng-template>
          </mat-tab>
          <mat-tab label="Contract Numbers">
            <ng-template matTabContent>
              <app-qc-contract-numbers></app-qc-contract-numbers>
            </ng-template>
          </mat-tab>
          <mat-tab label="Deficiency Types">
            <ng-template matTabContent>
              <app-qc-deficiency-type></app-qc-deficiency-type>
            </ng-template>
          </mat-tab>
          <mat-tab label="Observation Comment Types">
            <ng-template matTabContent>
              <app-qc-observation-comment-types></app-qc-observation-comment-types>
            </ng-template>
          </mat-tab>
          <mat-tab label="Origin Types">
            <ng-template matTabContent>
              <app-qc-origin-types></app-qc-origin-types>
            </ng-template>
          </mat-tab>
          <mat-tab label="Root Causes">
            <ng-template matTabContent>
              <app-qc-root-causes></app-qc-root-causes>
            </ng-template>
          </mat-tab>
          <mat-tab label="Responsible Managers">
            <ng-template matTabContent>
              <app-qc-responsible-manager></app-qc-responsible-manager>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel >
      <mat-expansion-panel-header>
        <mat-panel-title>Publications</mat-panel-title>
        <mat-panel-description><i>Pub Index Types, Publications</i></mat-panel-description>
      </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
      <mat-tab-group>
        <mat-tab label="Pub Index Types">
          <ng-template matTabContent>
            <app-qc-pub-index-types></app-qc-pub-index-types>
          </ng-template>
        </mat-tab>
        <mat-tab label="Publications">
          <ng-template matTabContent>
            <app-qc-publications></app-qc-publications>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel >
      <mat-expansion-panel-header>
        <mat-panel-title>Reports</mat-panel-title>
        <mat-panel-description><i>Master Report Listing, Report Schedule Frequencies, Inspection References, Inspection Sequences</i></mat-panel-description>
      </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
      <mat-tab-group>
        <mat-tab label="Master Report Listing">
          <ng-template matTabContent>
            <app-qc-master-report-listing></app-qc-master-report-listing>
          </ng-template>
        </mat-tab>
        <mat-tab label="Report Schedule Frequencies">
          <ng-template matTabContent>
            <app-qc-report-schedule-freq></app-qc-report-schedule-freq>
          </ng-template>
        </mat-tab>
        <mat-tab label="Inspection References">
          <ng-template matTabContent>
            <app-qc-inspection-references></app-qc-inspection-references>
          </ng-template>
        </mat-tab>
        <mat-tab label="Inspection Sequences">
          <ng-template matTabContent>
            <app-qc-inspection-sequences></app-qc-inspection-sequences>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
      </ng-template>
    </mat-expansion-panel>

     <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Checklists</mat-panel-title>
        <mat-panel-description><i>Responsible Assignments</i></mat-panel-description>
      </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
      <mat-tab-group>
        <mat-tab label="Responsible Assignments">
          <ng-template matTabContent>
            <app-qc-responsible-assignments></app-qc-responsible-assignments>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>

</div>
